import type { Form } from '../../../../common/types/form';
import type { Child } from '../../../../common/types/child';

const childCareCostsDataForm: Form<Child> = {
  key: 'childCareCostsData',
  title: 'Betreuungskosten',
  fields: [
    {
      key: 'isCoverageOfCareCostsRequested',
      label: 'Übernahme Betreuungskosten beantragt',
      fieldTypes: 'checkbox',
    },
    {
      key: 'coverageOfCareCostsRequestDate',
      label: 'Datum des Antrags',
      fieldTypes: 'date',
    },
    {
      key: 'isCoverageOfCareCostsApproved',
      label: 'Antrag wurde bewilligt',
      fieldTypes: 'checkbox',
      breakRowAfterField: true,
    },
    {
      key: 'coverageOfCareCostsStart',
      label: 'von',
      fieldTypes: 'date',
    },
    {
      key: 'coverageOfCareCostsEnd',
      label: 'bis',
      fieldTypes: 'date',
    },
    {
      key: 'but',
      label: 'BUT',
      fieldTypes: 'headline',
    },
    {
      key: 'isButRequested',
      label: 'BUT beantrangt',
      fieldTypes: 'checkbox',
    },
    {
      key: 'butRequestDate',
      label: 'Datum des Antrags',
      fieldTypes: 'date',
    },
    {
      key: 'butRequestApproved',
      label: 'BUT wurde bewilligt',
      fieldTypes: 'checkbox',
      breakRowAfterField: true,
    },
    {
      key: 'butRequestStart',
      label: 'von',
      fieldTypes: 'date',
    },
    {
      key: 'butRequestEnd',
      label: 'bis',
      fieldTypes: 'date',
    },
    {
      key: 'hotMeal',
      label: 'Warmes Mittagessen',
      fieldTypes: 'headline',
    },
    {
      key: 'isHotMealRequested',
      label: 'Warmes Mittagessen',
      fieldTypes: 'checkbox',
    },
    {
      key: 'hotMealProvider',
      label: 'Anbieter',
      fieldTypes: 'text',
    },
  ],
};

export default childCareCostsDataForm;
